/**
 * Retail POS Payment Method Registry.
 *
 * Declarative presentation / API mapping contract for payment methods
 * already demonstrated by the certified legacy Payment UX.
 *
 * This registry does not own:
 *
 * - payment execution;
 * - Receipt state;
 * - payment state;
 * - accounting;
 * - Cash change calculation;
 * - terminal integration;
 * - persistence;
 * - Company scope;
 * - Activity scope.
 *
 * Unsupported / future payment methods must not be invented here without
 * an audited backend or product contract.
 */

export const RETAIL_POS_PAYMENT_METHODS =
  Object.freeze([
    Object.freeze({
      id: "tpe",
      label: "TPE",
      apiValue: "card",
      kind: "card",
    }),

    Object.freeze({
      id: "cash",
      label: "Espèces",
      apiValue: "cash",
      kind: "cash",
    }),

    Object.freeze({
      id: "resto",
      label: "Resto",
      apiValue:
        "restaurant_ticket",
      kind: "voucher",
    }),

    Object.freeze({
      id: "nfc",
      label: "Sans Contact",
      apiValue: "card",
      kind: "card",
    }),

    Object.freeze({
      id: "amex",
      label: "AMEX",
      apiValue: "card",
      kind: "card",
    }),

    Object.freeze({
      id: "cheque",
      label: "Chèque",
      apiValue: "check",
      kind: "check",
    }),
  ]);


const PAYMENT_METHOD_BY_ID =
  new Map(
    RETAIL_POS_PAYMENT_METHODS.map(
      (method) => [
        method.id,
        method,
      ]
    )
  );


export function listRetailPOSPaymentMethods() {
  return RETAIL_POS_PAYMENT_METHODS;
}


export function getRetailPOSPaymentMethod(
  methodId
) {
  if (
    typeof methodId !== "string"
    || !methodId.trim()
  ) {
    return null;
  }

  return (
    PAYMENT_METHOD_BY_ID.get(
      methodId.trim()
    )
    ?? null
  );
}


export function resolveRetailPOSPaymentApiValue(
  methodId
) {
  return (
    getRetailPOSPaymentMethod(
      methodId
    )?.apiValue
    ?? null
  );
}


export function isRetailPOSPaymentMethodSupported(
  methodId
) {
  return (
    getRetailPOSPaymentMethod(
      methodId
    ) !== null
  );
}
